<template>
  <div>
    <div class="table-operations">
      <a-button
        class="left-button"
        icon="bars"
        @click="showDetail()"
        :disabled="!hasSelected"
      >Tampilkan Rincian</a-button>
      <!-- <a-button class="right-button" icon="table"></a-button> -->
      <a-dropdown class="right-button" :trigger="['click']" v-model="visible">
        <a-button icon="table"></a-button>
        <a class="right-button ant-dropdown-link">
          <a-icon type="table"/>
        </a>
        <a-menu slot="overlay">
          <a-menu-item v-for="(col, index) in columns" :key="index">
            <a-checkbox
              :defaultChecked="true"
              :checked="col.visible"
              @change="checkboxChange($event,index)"
            >{{col.title}}</a-checkbox>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <div class="table-container">
      <a-table
        :rowKey="record => record.awbNumber"
        :columns="visibleColumns"
        :dataSource="data"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        size="small"
        bordered
        :scroll="tableScroll"
      >
        <!-- eslint-disable-next-line vue/no-parsing-error -->
        <template v-if="last_status" slot="tags" slot-scope="last_status, record">
          <a-popover :title="last_status" trigger="hover" placement="leftTop">
            <template slot="content">
              <p style="max-width: 300px;" v-html="record.last_status_desc"></p>
            </template>
            <a-tag v-if="last_status=='Delivered'" color="#33BF33">{{last_status}}</a-tag>
            <a-tag
              v-else-if="last_status=='Arrival Origin' || last_status=='Arrive Facility'"
              color="#F67141"
            >{{last_status}}</a-tag>
            <a-tag
              v-else-if="last_status=='Out Bound' || last_status=='With Courier'"
              color="#E2C42B"
            >{{last_status}}</a-tag>
            <a-tag v-else color="#1B68DA">{{last_status}}</a-tag>
          </a-popover>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ShipmentService from "@/services/ShipmentService";
import router from "../../router";
import qs from "qs";

var columns = [
  {
    title: "Tanggal",
    sorter: true,
    dataIndex: "pickupDate",
    width: 100,
    visible: true
  },
  {
    title: "No STTB",
    dataIndex: "awbNumber",
    sorter: true,
    visible: true
  },
  {
    title: "No Ref",
    sorter: true,
    dataIndex: "refNumber",
    width: 50,
    visible: false
  },
  {
    title: "Pengirim",
    sorter: true,
    dataIndex: "senderName",
    visible: true
  },
  {
    title: "Kota Asal",
    sorter: true,
    dataIndex: "senderCity",
    visible: true
  },
  {
    title: "Penerima",
    sorter: true,
    dataIndex: "destName",
    visible: true
  },
  {
    title: "Kota Tujuan",
    sorter: true,
    dataIndex: "destCity",
    visible: true
  },
  {
    title: "Product",
    sorter: true,
    dataIndex: "productType",
    visible: true
  },
  {
    title: "Coli",
    sorter: true,
    dataIndex: "coli",
    visible: true
  },
  {
    title: "Kg",
    sorter: true,
    dataIndex: "weight",
    visible: true
  },
  {
    title: "Status",
    sorter: false,
    dataIndex: "last_status",
    scopedSlots: { customRender: "tags" },
    visible: true
  }
];

export default {
  mounted() {
    this.fetch();
  },
  data() {
    return {
      data: [],
      visible: false,
      checked: true,
      pagination: {
        showSizeChanger: true,
        showTotal: function(total, range) {
          return range[0] + " - " + range[1] + " 0f " + total + " items";
        },
        pageSizeOptions: ["10", "20", "50", "100"]
      },
      loading: false,
      selectedRowKeys: [],
      columns,
      tableScroll: {},
      period: new Date().getFullYear(),
      sortedInfo: {}
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      var order = "";

      if (Object.keys(sorter).length === 0) {
        order = "pickupDate DESC";
        this.sortedInfo = {
          field: "pickupDate",
          order: "descend"
        };
      } else {
        order =
          sorter.field + " " + (sorter.order == "ascend" ? "ASC" : "DESC");

        this.sortedInfo = sorter;
      }

      pager.current = pagination.current;
      this.pagination = pager;

      this.fetch({
        limit: pagination.pageSize,
        offset: (pagination.current - 1) * pagination.pageSize,
        filter: this.filters,
        order: order ? order : "pickupDate DESC",
        include_count: true,
        ...filters
      });
    },
    fetch(params = {}) {
      const vthis = this;
      vthis.loading = true;

      // eslint-disable-next-line no-console

      if (Object.keys(params).length === 0) {
        this.sortedInfo = {
          field: "pickupDate",
          order: "descend"
        };

        params = {
          limit: 10,
          offset: 0,
          include_count: true,
          filter: this.filters,
          order: "pickupDate DESC"
        };
      }

      ShipmentService.getShipmentData(
        params,
        function(data) {
          const pagination = { ...vthis.pagination };
          const results = data.data;
          const meta = results.meta;
          pagination.total = meta.count;
          vthis.loading = false;
          vthis.data = results.resource;
          vthis.pagination = pagination;
        },
        function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        }
      );
    },
    showDetail() {
      // router.push("/myshipment/detail");
      const query = qs.stringify(this.selectedRowKeys, { encode: false });

      router.push({ path: "/myshipment/detail", query: { ids: query } });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    checkboxChange(event, index) {
      this.columns[index].visible = !this.columns[index].visible;
      if (this.visibleColumns.length == this.columns.length) {
        this.tableScroll = { x: "10%" };
      } else {
        this.tableScroll = {};
      }
    }
  },
  computed: {
    ...mapGetters("shipment", ["filters"]),
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
    visibleColumns() {
      var visColumns = [];

      for (let index = 0; index < this.columns.length; index++) {
        const element = this.columns[index];
        if (element.visible) {
          visColumns.push(element);
        }
      }

      return visColumns;
    }
  },
  watch: {
    filters() {
      this.fetch();
    }
  }
};
</script>
<style>
#moduletitle {
  padding: 10px;
}
.table-operations {
  margin-top: 16px;
  margin-bottom: 16px;
}

.table-operations > button,
.table-operations > .ant-select {
  margin-right: 8px;
}

.ant-popover-title {
  font-weight: 600;
}

.left-button {
  float: left;
}

.right-button {
  float: right;
}

.table-container {
  padding-top: 15px;
  clear: both;
}
</style>